import React, { useState, useEffect } from "react";
import HeadLines from "../../CommonComponents/HeadLines";
import { isMobile } from "../../helperFunc";
import style from "./style.module.css";
import { downArrow } from "../../icon_assets";
import TwoLineWidget from "../../CommonComponents/TwoLineWidget/TwoLineWidget";
import Button from "../../CommonComponents/Button";
import FlexComponentMobile from "../../Trade/Listing/HomepageRevamp4.0/FlexComponentMobile/FlexComponentMobile";
import { useHistory } from "react-router";
import useIsUserLoggedIn from "../../CustomHooks/useIsUserLoggedIn";
import {
  getCaseDetails,
  getServiceRequest,
} from "../../../../../_services/Arya2.0/Homepage";
import { customToastr } from "../../CustomToastr";
import MultiLangTranslate from "../../../../../_components/Translate/MultiLangTranslate";
import Loader from "../../CommonComponents/Loader/Loader";

const ServiceRequest = ({ getInTouchSubmitted = 0 }) => {
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [data, setData] = useState([]);
  const [userLoggedIn] = useIsUserLoggedIn();
  const history = useHistory();
  const [isLoading, setIsloading] = useState(false);
  const [totalCount, setTotalCount] = useState(6);

  const getServiceRequestData = async () => {
    setIsloading(true);
    try {
      const params = { pageNumber: 1, pageSize: 3, status: "PENDING" };
      const queryParams = new URLSearchParams(params).toString();
      const response = await getServiceRequest(`?${queryParams}`);
      if (response?.status_code === 200 && response?.data) {
        setData(response?.data?.list || []);
      }
    } catch (error) {
      customToastr({
        type: "warning",
        timeOut: 3000,
        text: error?.message || "Something went wrong",
      });
    } finally {
      setIsloading(false);
    }
  };

  useEffect(() => {
    if (userLoggedIn) {
      getServiceRequestData();
    }
  }, [userLoggedIn, getInTouchSubmitted]);

  const handleViewAll = () => {
    history.push("/service-requests");
  };

  const toggleDropdown = (index) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleViewClick = async (caseId) => {
    const dataObj = {
      caseId: caseId,
    };
    const res = await getCaseDetails(dataObj);

    if (res?.status_code === 200) {
      if (res?.data?.caseId && res?.data?.caseType === "WAREHOUSE_BOOKING") {
        let warehouseName = res?.data?.data?.warehouseDetail?.name.replace(
          /\s+/g,
          "-"
        );

        let warehouseId =
          res?.data?.data?.warehouseDetail?.location?.warehouseId;
        let locationId =
          res?.data?.data?.warehouseDetail?.location?.geoLocationId;
        history.push({
          pathname: `/warehouse/detail/${warehouseName}/${warehouseId}`,
          state: { locationId: locationId },
        });
      }
    }
  };

  return (
    <>
      <Loader isLoading={isLoading} />

      {data && data?.length > 0 && (
        <div className={isMobile ? `margin-top20` : `margin-top30`}>
          {isMobile ? (
            <FlexComponentMobile
              leftTitle="Service Requests"
              rightNumber={data?.length || 0}
            />
          ) : (
            <div className="d-flex align-items-center justify-content-space-between">
              <div className="d-flex align-items-center gap8">
                <HeadLines
                  text="Service Requests"
                  className={
                    isMobile
                      ? ``
                      : `font-weight500 font-size18 line-height21 colorDark5`
                  }
                />
                <HeadLines
                  text={data?.length.toString().padStart(2, "0")}
                  className={
                    isMobile
                      ? ``
                      : `font-weight500 font-size18 line-height21 backAccent3 textColorWhite boxRadius4 ${style.padding4_5}`
                  }
                />
              </div>
              {totalCount > 3 && (
                <div className="d-flex align-items-center gap20">
                  <Button
                    title="View All"
                    onClick={handleViewAll}
                    className={`${
                      isMobile
                        ? "font-size14 line-height16 colorAccent3"
                        : "font-size16 line-height19 colorAccent3"
                    } font-weight500 cursorPointer ${
                      style.transparentbackground
                    }`}
                  />
                </div>
              )}
            </div>
          )}

          {isMobile ? (
            <div className="margin-bottom24">
              <div
                className={`margin-top12 d-flex align-items-center gap10 flex-d-col`}
              >
                {data?.map((item, index) => (
                  <div
                    key={index}
                    className={`padding16 ${style.lightBlue2} boxRadius8 width-100`}
                  >
                    <div className="d-flex align-items-center justify-content-space-between">
                      <TwoLineWidget
                        subtitle={item?.serialNumber?.toString()}
                        title="Case Id"
                        titleClassName={`font-weight400 font-size10 line-height12 letterSpacing05 ${style.blackColor}`}
                        subtitleClassName={`font-weight600 font-size14 line-height16 letterSpacing05 ${style.blackColor}`}
                      />
                      <div
                        className={`d-flex align-items-center justify-content-space-between ${style.gap30}`}
                      >
                        <div className={`${style["mobStatusDiv"]}`}>
                          <div className={`${style["mobStatus"]}`}>
                            {item?.status}
                          </div>
                        </div>
                        <img
                          src={downArrow}
                          className={!openDropdowns[index] && style.closeArrow}
                          onClick={() => toggleDropdown(index)}
                          alt="Toggle"
                        />
                      </div>
                    </div>
                    {openDropdowns[index] && (
                      <div>
                        <div className={style.lineCss} />
                        <div className={style.gridContainer}>
                          <TwoLineWidget
                            subtitle={item?.date}
                            title="Date"
                            titleClassName={`font-weight400 font-size10 line-height12 letterSpacing05 ${style.blackColor}`}
                            subtitleClassName={`font-weight600 font-size14 line-height16 letterSpacing05 ${style.blackColor}`}
                          />
                          <TwoLineWidget
                            subtitle={item?.type}
                            title="Type"
                            titleClassName={`font-weight400 font-size10 line-height12 letterSpacing05 ${style.blackColor}`}
                            subtitleClassName={`font-weight600 font-size14 line-height16 letterSpacing05 ${style.blackColor}`}
                          />
                          <TwoLineWidget
                            subtitle={item?.pendingAt}
                            title="Pending at"
                            titleClassName={`font-weight400 font-size10 line-height12 letterSpacing05 ${style.blackColor}`}
                            subtitleClassName={`font-weight600 font-size14 line-height16 letterSpacing05 ${style.blackColor}`}
                          />
                          <TwoLineWidget
                            subtitle={item?.status}
                            title="Status"
                            titleClassName={`font-weight400 font-size10 line-height12 letterSpacing05 ${style.blackColor}`}
                            subtitleClassName={`font-weight600 font-size14 line-height16 letterSpacing05 ${style.blackColor}`}
                          />
                        </div>
                        <div className="d-flex justify-content-center margin-top12 textCenter">
                          {item?.type !== "GET_IN_TOUCH" ? (
                            <div
                              className={`${style.deskViewButton} ${style["minWidth16"]} textCenter cursor-pointer`}
                              onClick={() =>
                                handleViewClick(item?.serialNumber)
                              }
                            >
                              <MultiLangTranslate title="View" />
                            </div>
                          ) : (
                            <div
                              className={
                                isMobile ? "" : `${style["minWidth16"]}`
                              }
                            ></div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
              {totalCount > 4 && (
                <div className="text-align-right">
                  <Button
                    title="View All"
                    onClick={handleViewAll}
                    className={`font-size14 line-height16 colorAccent3 font-weight500 cursorPointer margin-top16 ${style.transparentbackground}`}
                  />
                </div>
              )}
            </div>
          ) : (
            <div
              className={
                isMobile
                  ? ``
                  : `margin-top20 boxRadius8 ${style["divBorder"]} padding-top16 padding-bottom16 padding-left16 padding-right16 d-flex align-items-center flex-d-col`
              }
            >
              {data?.map((item, index) => (
                <div
                  key={index}
                  // onClick={() => handleViewClick(item?.serialNumber)}
                  className={`d-flex text-align-left cursorPointer  ${style.widgetDiv} width-100 align-items-center ${style.lightColorblue} padding-top16 gap20 padding-bottom16 padding-left16 padding-right16 ${style.boxradius16}`}
                >
                  <TwoLineWidget
                    subtitle="Case Id"
                    title={item?.serialNumber?.toString()}
                    titleClassName={`${
                      isMobile
                        ? style["mobiletitle-2-line"]
                        : style["title-2-line"]
                    }`}
                    subtitleClassName={`${
                      isMobile
                        ? style["mobilesubtitle-2-line"]
                        : style["subtitle-2-line"]
                    } ${style["fontWeight700"]}`}
                    className={
                      isMobile
                        ? `margin-top12 margin-bottom12`
                        : `${style["width10"]}`
                    }
                  />
                  <TwoLineWidget
                    title={item?.date}
                    subtitle="Date"
                    titleClassName={`${
                      isMobile
                        ? style["mobiletitle-2-line"]
                        : style["title-2-line"]
                    }`}
                    subtitleClassName={`${
                      isMobile
                        ? style["mobilesubtitle-2-line"]
                        : style["subtitle-2-line"]
                    } ${style["fontWeight700"]}`}
                    className={
                      isMobile
                        ? `margin-top12 margin-bottom12`
                        : `${style["minWidth16"]}`
                    }
                  />
                  <TwoLineWidget
                    title={item?.type}
                    subtitle="Type"
                    titleClassName={`${
                      isMobile
                        ? style["mobiletitle-2-line"]
                        : style["title-2-line"]
                    }`}
                    subtitleClassName={`${
                      isMobile
                        ? style["mobilesubtitle-2-line"]
                        : style["subtitle-2-line"]
                    } ${style["fontWeight700"]}`}
                    className={
                      isMobile
                        ? `margin-top12 margin-bottom12`
                        : `${style["minWidth16"]}`
                    }
                  />
                  <TwoLineWidget
                    title={item?.pendingAt}
                    subtitle="Pending at"
                    titleClassName={`${
                      isMobile
                        ? style["mobiletitle-2-line"]
                        : `${style["title-2-line"]} ${style["yellowColor"]}`
                    }`}
                    subtitleClassName={`${
                      isMobile
                        ? style["mobilesubtitle-2-line"]
                        : style["subtitle-2-line"]
                    } ${style["fontWeight700"]}`}
                    className={
                      isMobile
                        ? `margin-top12 margin-bottom12`
                        : `${style["minWidth16"]}`
                    }
                  />
                  <TwoLineWidget
                    title={item?.status}
                    subtitle="Status"
                    titleClassName={`${
                      isMobile
                        ? style["mobiletitle-2-line"]
                        : style["title-2-line"]
                    }`}
                    subtitleClassName={`${
                      isMobile
                        ? style["mobilesubtitle-2-line"]
                        : style["subtitle-2-line"]
                    } ${style["fontWeight700"]}`}
                    className={
                      isMobile
                        ? `margin-top12 margin-bottom12`
                        : `${style["minWidth16"]}`
                    }
                  />

                  {item?.type !== "GET_IN_TOUCH" ? (
                    <div
                      className={
                        isMobile
                          ? ""
                          : `${style.deskViewButton} ${style["minWidth16"]} textCenter cursor-pointer`
                      }
                      onClick={() => handleViewClick(item?.serialNumber)}
                    >
                      <MultiLangTranslate title="View" />
                    </div>
                  ) : (
                    <div
                    className={
                      isMobile
                        ? ""
                        : `${style.disabledeskViewButton} ${style["minWidth16"]} textCenter cursor-pointer`
                    }
                    // onClick={() => handleViewClick(item?.serialNumber)}
                  >
                    <MultiLangTranslate title="View" />
                  </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ServiceRequest;
